import { unmountComponentAtNode } from 'react-dom';

export class BaseDialog<T> {
  public el: any | null = null;

  resolvePromise = (e: any) => false;
  rejectPromise = (e: any) => false;

  public promise: Promise<T> = new Promise((resolve: any, reject: any) => {
    this.resolvePromise = resolve;
    this.rejectPromise = reject;
  });

  constructor() {
    // allow dialog to be closed ONLY after a timeout
    setTimeout(() => {
      window.addEventListener('keyup', this.handleKeyUp, true);
    }, 1000);
  }

  unmount = () => {
    window.removeEventListener('keyup', this.handleKeyUp, true);
    document.body.removeChild(this.el);
    unmountComponentAtNode(this.el as any);
  };

  public close = (evt?: any) => {
    evt?.preventDefault();
    evt?.stopPropagation();

    this.resolvePromise(false);
    this.unmount();
  };

  confirm = (evt: any) => {
    evt.preventDefault();
    evt.stopPropagation();

    this.resolvePromise(true);
    this.unmount();
  };

  handleKeyUp = (e: KeyboardEvent) => {
    if (e.which === 27) {
      // escape key
      this.close();
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    } else if (e.which === 13) {
      // enter key
      this.confirm(e);
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  };
}
